import { render, staticRenderFns } from "./CreateCourseCategoryDialog.vue?vue&type=template&id=1af59d54&scoped=true"
import script from "./CreateCourseCategoryDialog.vue?vue&type=script&lang=js"
export * from "./CreateCourseCategoryDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateCourseCategoryDialog.vue?vue&type=style&index=0&id=1af59d54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af59d54",
  null
  
)

export default component.exports